// src/data/dropdownOptions.js

export const companyTypes = [
  "Sole Proprietorship",
  "Partnership",
  "Corporation",
  "Non-Profit",
  "Other",
];

export const businessCategories = [
  "SaaS",
  "E-commerce",
  "FinTech",
  "Healthcare Services",
  "Manufacturing",
  "Education",
  "Retail",
  "Logistics",
  "Marketing",
  "Consulting",
  "Non-profit",
  "Other",
];

export const businessIndustries = [
  "Technology",
  "Finance",
  "Healthcare",
  "Education",
  "Manufacturing",
  "Retail",
  "Transportation",
  "Media & Entertainment",
  "Hospitality",
  "Agriculture",
  "Energy & Utilities",
  "Construction",
  "Real Estate",
  "Legal Services",
  "Automotive",
  "Telecommunications",
  "Food & Beverage",
  "Travel & Tourism",
  "Government",
  "Non-profit",
  "Other",
];
